import './button-bullet.scss'

const ButtonBullet = props => {
	const { children, active = false, onClick } = props

	return (
		<button className={`a-button-bullet ${active ? 'active' : ''}`} onClick={onClick || null}>
			{children}
		</button>
	)
}

export default ButtonBullet
